// extracted by mini-css-extract-plugin
module.exports = {"MainNav__Logo":"logo_MainNav__Logo__j0c7g"};